import { GlobalDataLayerService } from "./global-data-layer-service";
import { EventAction, EventActions } from "../../utility/constants";

interface ComponentClick {
  clickElementId: string;
  clickElementName: string;
  targetUrl: string;
}
export class DataLayerEventBuilder {
  private eventAction: EventAction = EventActions.GENERAL_LOAD;

  private eventAttributes: Partial<{
    componentClick: Partial<ComponentClick>;
  }> = {};

  public withAction(action: EventAction): void {
    this.eventAction = action;
  }

  public withComponentClick(attrs: Partial<ComponentClick>): void {
    this.eventAttributes.componentClick = attrs;
  }

  public pushEvent(): void {
    GlobalDataLayerService.getInstance().pushDataLayerEvent(
      this.eventAction,
      this.eventAttributes,
    );
  }
}
